"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IdStore = void 0;
const utils_1 = require("../../../utils");
exports.IdStore = {
    _namespace_: "idStore",
    async store(address, credId, credCosePublicKey, opts = {}) {
        const { nonce } = opts;
        const m = new Map();
        m.set(0, address);
        m.set(1, Buffer.from(credId));
        m.set(2, credCosePublicKey);
        const message = await this.call("idstore.store", m, {
            nonce,
        });
        return getPhrase(message);
    },
    async getFromRecallPhrase(phrase, { nonce } = { nonce: (0, utils_1.makeRandomBytes)(16) }) {
        const val = phrase.trim().split(" ");
        const message = await this.call("idstore.getFromRecallPhrase", new Map([[0, val]]), {
            nonce,
        });
        return getCredentialData(message);
    },
    async getFromAddress(address, { nonce } = { nonce: (0, utils_1.makeRandomBytes)(16) }) {
        const message = await this.call("idstore.getFromAddress", new Map([[0, address]]), {
            nonce,
        });
        return getCredentialData(message);
    },
};
function getPhrase(m) {
    var _a;
    const result = { phrase: "" };
    const payload = m.getPayload();
    if (payload) {
        result.phrase = (_a = payload === null || payload === void 0 ? void 0 : payload.get(0)) === null || _a === void 0 ? void 0 : _a.join(" ");
    }
    return result;
}
function getCredentialData(m) {
    const result = { credentialId: undefined, cosePublicKey: undefined };
    const payload = m.getPayload();
    if (payload) {
        if (payload.has(0) && payload.has(1)) {
            result.credentialId = payload.get(0);
            result.cosePublicKey = payload.get(1);
        }
    }
    return result;
}
